import CardActions from "@mui/material/CardActions";
import { withStyles } from "tss-react/mui";

const styles = {
    root: {
        "& > div": {
            margin: 0,
        },
        "& a": {
            borderRadius: 0,
            margin: 0,
        },
        "& button": {
            borderRadius: 0,
            margin: 0,
        },
        padding: 0,
    },
};

export const VariantCardActions = withStyles(CardActions, () => styles);
